module.exports = __webpack_public_path__ + "static/img/2.ca84600.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/2.png
// module id = FS1h
// module chunks = 0